// returns true if the form is invalid (e.g. should disable "submit" button)
const invalidCheckoutForm = ({ account, paymentProfileForm, waiverForms }) =>
  invalidSavedPayment({ account, paymentProfileForm }) ||
  invalidContactInfo({ paymentProfileForm }) ||
  invalidWaiverForms(waiverForms)

const invalidSavedPayment = ({ account, paymentProfileForm }) =>
  account &&
  !account.paymentProfile &&
  paymentProfileForm &&
  paymentProfileForm.paymentMethod == 'saved'

const invalidWaiverForms = waiverForms =>
  waiverForms && waiverForms.find(wf => !wf.consent || !wf.acceptedBy)

const invalidContactInfo = ({ paymentProfileForm }) =>
  paymentProfileForm &&
  paymentProfileForm.paymentMethod !== 'saved' &&
  !(
    paymentProfileForm.firstName &&
    paymentProfileForm.lastName &&
    paymentProfileForm.city &&
    paymentProfileForm.country &&
    paymentProfileForm.email &&
    paymentProfileForm.postalCode &&
    paymentProfileForm.primaryPhone &&
    paymentProfileForm.region &&
    paymentProfileForm.streetAddress
  )

export { invalidCheckoutForm }
